import { SalesStore } from 'store/sales/types.ts'
import { LANGUAGES, ROLES } from '@boltenergy-be/shared'

export const initialSalesStore: SalesStore = {
  _id: '',
  agentId: '',
  activated: false,
  firstName: '',
  lastName: '',
  email: '',
  language: LANGUAGES.NL,
  partner: {
    id: '',
    name: '',
    allowAccessToAllCustomers: false
  },
  role: ROLES.salesPortal,
  loading: true,
  error: null
}
